module.exports = __webpack_public_path__ + "static/img/8.12fbdb39.png";